












































import { Vue, Component } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
import exicon from '../../assets/js/expressicon'
const basis = namespace('basis') //getMailList
const common = namespace('common')
@Component
export default class Home extends Vue{
    site:string = ''
    exicon:any = exicon
    partner:string = '' //快递员id
    daterange:any = [] //入库时间断
    @basis.State('mailPager') mailPager:any //表格的页码
    @basis.State('mailList') mailList:any //快递员列表
    @basis.State('loading') loading:any //快递员列表
    @common.State('partnerList') partnerList:any
    get search(){
        let star = ''
        let end = ''
        if(this.daterange){
            star = this.daterange[0]
            end = this.daterange[1]
        }
        return {
            site: this.site,
            code: '',
            phone: '',
            partner: this.partner,
            star: star,
            end: end,
            pageSize: 20,
            page: 1
        }
    }
    get tablecolumn(){
        return [
            {
                name: 'code',
                type: 'slot',
                label: '快递单号',

            },
            {
                prop: 'Sender',
                name: 'Sender',
                type: 'slot',
                label: '寄件人信息',

            },
            {
                prop: 'Receiver',
                name: 'Receiver',
                type: 'slot',
                label: '收件人信息',

            },
            {
                prop: 'partner',
                name: 'partner',
                label: '快递单位',
                type: 'nextProp',
                nextProp: 'name'
            },
            {
                prop: 'ctime',
                type: 'text',
                label: '创建时间',

            },
            {
                prop: 'GoodsWeight',
                type: 'text',
                label: '重量（KG）',

            },
            {
                prop: 'money',
                type: 'text',
                label: '费用',

            },
            {
                prop: 'cost',
                type: 'text',
                label: '成本',

            }
        ]
    }
    @basis.Action('getMailList') getMailList:any
    created(){
        this.getList()
    }
    getList(){
        this.getMailList(this.search)
    }
    // 翻页
    pagechange(e:any){
        this.search.page = e[0].val
        this.getList()
    }
    // 点击查询按钮
    queryData(val:string){
        this.search.page = 1;
        this.getList()
    }
    // 网点改变的时候
    changeSite(val:string){
        this.site = val
        this.getList()
        
    }
    // 条数改变
    pageSizechange(e:any){
        this.search.pageSize = e[0].val
        this.getList()
    }
}
